// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"57":"fd698a83","369":"fd698a83"}[chunkId] + ".chunk.css";
};